export const allowanceFeatureKey = 'allowance';
